import { Stack} from '@mui/material';
import AquantLogo from './resources/images/logo_white.png'

import './Home.scss';
import { Term } from './components/Term';
import { GlossaryTerms } from './resources/GlosseryTerms';
import { useEffect, useState } from 'react';


interface HomeProps {
}

const Home = ({ }: HomeProps) => {
  const [selectedLetter, setSelectedLetter] = useState('')
  const [selectedLetterIndex, setSelectedLetterIndex] = useState(0)

  useEffect(() => {
    const items = document.getElementsByClassName(selectedLetter);
    const itemToScrollTo = items[selectedLetterIndex%items.length]
    if (itemToScrollTo) {
      const targetPosition = itemToScrollTo.getBoundingClientRect().top + window.scrollY - 290;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  } ,[selectedLetter, selectedLetterIndex])
  
  const sorted_terms = GlossaryTerms.sort((a, b) => a.term.toLowerCase().localeCompare(b.term.toLowerCase()))
  const refIds = {}
  sorted_terms.forEach(t => {
    const letter = t.term.toUpperCase()[0]
    if (letter in refIds) return
    refIds[letter] = t.term
  })

  const uppercaseLetters = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

  const handleClick = (id) => {
    if (id === selectedLetter) setSelectedLetterIndex(selectedLetterIndex + 1)
    else {
      setSelectedLetterIndex(0)
      setSelectedLetter(id)
    }
  };
  
  return (
    <Stack className='Home' >
      <Stack  className='Header'>
        <Stack  className='Content'>
          <Stack direction='row' className='TitleBar'>
            <img className='Shoulder' src={AquantLogo} alt=''/>
            <div className='Title'>Glossary</div>
            <div className='Shoulder'></div>
          </Stack>  
          <Stack direction='row' className='Letters'>
            {uppercaseLetters.map(l =>  l in refIds ? 
              <div className='Letter Enabled' onClick={() => handleClick(l)}>{l}</div> : 
              <div className='Letter'>{l}</div>)}
          </Stack>
        </Stack>
      </Stack>
      <Stack className='Body'> {sorted_terms.map(t => <Term {...t}/>)} </Stack>
    </Stack>
  );
};

export default Home;